const HYDRATE_FILTER_VALUES = 'HYDRATE_FILTER_VALUES';
const RESET_ALL_FILTERS = 'RESET_ALL_FILTERS';
const RESET_FILTER = 'RESET_FILTER';

/* Player Details */
const SET_PLAYER_SEARCH = 'SET_PLAYER_SEARCH';
const SET_PLAYER_NATIONALITY = 'SET_PLAYER_NATIONALITY';
const SET_DOMINANT_HAND = 'SET_DOMINANT_HAND';
const SET_DRAFT_PICK_RANGE = 'SET_DRAFT_PICK_RANGE';
const SET_DRAFT_ROUND = 'SET_DRAFT_ROUND';
const SET_DRAFT_YEAR = 'SET_DRAFT_YEAR';
const SET_EXPERIENCE = 'SET_EXPERIENCE';
const SET_STATE_OR_PROVINCE = 'SET_STATE_OR_PROVINCE';
const SET_STATUS = 'SET_STATUS';

/* Game Details */
const SET_DECISION = 'SET_DECISION';
const SET_GAME_LOCATION = 'SET_GAME_LOCATION';
const SET_OPPONENT = 'SET_OPPONENT';

/* Filter Results By (the column filters) */
const SET_CUSTOM_FILTERS = 'SET_CUSTOM_FILTERS';

export default {
    HYDRATE_FILTER_VALUES,
    RESET_ALL_FILTERS,
    RESET_FILTER,

    SET_PLAYER_SEARCH,
    SET_PLAYER_NATIONALITY,
    SET_DOMINANT_HAND,
    SET_DRAFT_PICK_RANGE,
    SET_DRAFT_ROUND,
    SET_DRAFT_YEAR,
    SET_EXPERIENCE,
    SET_STATE_OR_PROVINCE,
    SET_STATUS,

    SET_DECISION,
    SET_GAME_LOCATION,
    SET_OPPONENT,

    SET_CUSTOM_FILTERS,
};
